import { X } from "lucide-react";
import type { ReactNode } from "react";

export function Modal({
  open,
  title,
  children,
  onClose,
  wide = false
}: {
  open: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/35 p-4 backdrop-blur-sm">
      <div className={`modal-shell max-h-[92vh] w-full overflow-auto rounded-2xl bg-white shadow-2xl ${wide ? "max-w-4xl" : "max-w-xl"}`}>
        <div className="modal-header sticky top-0 z-10 flex items-center justify-between border-b border-slate-100 bg-white px-6 py-4">
          <h2 className="text-lg font-bold text-slate-950">{title}</h2>
          <button onClick={onClose} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100" aria-label="Fermer">
            <X size={18} />
          </button>
        </div>
        <div className="modal-body p-6">{children}</div>
      </div>
    </div>
  );
}
